import { Grid, Typography, Box, useTheme } from '@mui/material';
import { useForm } from 'react-hook-form';

import { updateNews2 } from 'apis/survey';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import MuiDialog from 'components/MuiDialog';
import {
  TNEWS2DefaultValues,
  SurveyDialogProps,
} from 'routes/Main/Survey/type';

import CommonPatientInfo from '../components/CommonPatientInfo';
import NEWS2Contents from './NEWS2Contents';
import ScoreBox from './ScoreBox';

const NEWS2 = (props: SurveyDialogProps<TNEWS2DefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    patientInfo,
    nurseName,
    onClose,
  } = props;
  const { palette } = useTheme();

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, watch, register, getValues, setValue } = useForm({
    defaultValues,
  });

  const onSubmit = (data: TNEWS2DefaultValues) => {
    const { patient_id } = patientInfo;
    const {
      respiration,
      hypercapnic,
      spo2Yes,
      spo2No,
      roomAir,
      temperatur,
      systolic,
      pulse,
      consciousness,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      news2_survey: { ...data },
    };

    updateNews2(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);
        onUpdateIsSave(true);
        onSuccess('저장되었습니다');
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          조기경고점수 (National Early Warning Score 2, NEWS 2)
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <NEWS2Contents {...formProps} />
        <ScoreBox />
      </Grid>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'flex-end'}
        sx={{ marginTop: '0px', width: '94%' }}
      >
        <Typography sx={{ fontSize: '12px', color: `${palette.primary.main}` }}>
          본 기록지의 저작권은 Dr. Gary B. Smith 에게 있습니다. <br />
          거제대학교 간호학과의 협조로 제작 되었습니다.
        </Typography>
      </Box>
    </MuiDialog.SurveyForm>
  );
};

export default NEWS2;
